<template>

  <div class="modal-dialog modal-lg">
    <!-- <div id="loading" v-if="loading">
      <img src="/images/watson-loading.gif" alt="Loading"/>
    </div> -->


    <div>
      <div class="modal-content">
        <div class="modal-body">
          <a href="#" class="close" @click.prevent="closeModal"><span aria-hidden="true">&times;</span></a>

          <div class="row">

            <div class="col-md-7">
              <h3 class="modal-title">{{selectedFellow.FirstName }} {{ selectedFellow.LastName}}</h3>
              <h6 id="fellow-college">{{ selectedFellow.Account.Name}}</h6>

              <hr/>

              <template v-if="selectedFellow.Applications__r && selectedFellow.Applications__r.records.length">

                <template v-if="selectedFellow.Applications__r.records[0].RecordType.Name == 'TJ Application' || selectedFellow.Applications__r.records[0].RecordType.Name == 'TJ Application-Offer'">
                  <h4><small>Project</small></h4>
                  <h2 id="fellow-project">{{selectedFellow.Applications__r.records[0].Proposed_Project_Title__c}}</h2>
                  <h5><small id="fellow-countries">{{ selectedFellow.Applications__r.records[0].Proposed_Project_Countries__c }}</small></h5>
                  <div id="fellow-description">
                    {{ selectedFellow.Applications__r.records[0].Summary_of_Proposed_Project__c }}
                  </div>
                </template>

                <template v-else>
                  <div id="fellow-description">
                    <h4><small>Bio</small></h4>
                    {{ selectedFellow.Applications__r.records[0].Professional_Aspiration__c }}
                  </div>
                </template>
              </template>

            </div>

            <div class="col-md-5 hidden-sm hidden-xs">

              <div class="img-circle img-tj" v-if="fellowPhoto" v-html="fellowPhoto">
              </div>

              <template v-if="continents && selectedFellow.Applications__r && selectedFellow.Applications__r.records.length && selectedFellow.Applications__r.records[0].Proposed_Project_Countries__c">
                <tj-modal-map :continents="continents" :countries="selectedFellow.Applications__r.records[0].Proposed_Project_Countries__c"></tj-modal-map>
              </template>

              <img v-else src="/images/profile-icon.png" width="202" height="202" alt="Profile icon"/>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import axios from 'axios'
import TjModalMap from "./tj-modal-map.vue";

export default {
  props: ['selectedFellow', 'continents'],
  data(){
    return{
      fellowPhoto: null,
      // loading: true
    }
  },

  async created() {
    const response = await axios.get("/actions/community/data/get-contact-photo-bg", {
        params: {
          contactId: this.selectedFellow.Id
        }
      })
    this.fellowPhoto = response.data
    // this.loading = false
    // this.$emit('loaded');
  },

  mounted() {
    console.log('tj modal mounted')
  },

  methods: {
    closeModal() {
      this.$emit('close-modal');
    }
  },
  components: {
    TjModalMap
  }
}

</script>

<styles>

.modal-dialog {
  background-color: blue;
  z-index: 100;
}

</styles>



// WEBPACK FOOTER //
// scripts/tj-modal.vue